import { Action } from './core/action';

export class ContractApproveAction implements Action {
  constructor(public data: any) {}
}



// WEBPACK FOOTER //
// src/app/common/actions/contract-approve-action.ts